import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  Chip,
} from "@material-ui/core";
import { MdOutlineSick, MdOutlineTagFaces } from "react-icons/md";
import PageTitle from "../../../components/PageTitle";
import { toast } from "react-toastify";
import { FaDotCircle, FaTrashAlt } from "react-icons/fa";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMonths } from "date-fns/addMonths";
import "../../../css/employee-page.css";
import { useNotification } from "../../../hooks/useNotification.js";
import { IoCheckmark, IoCloseOutline } from "react-icons/io5";
import { LuClock } from "react-icons/lu";
import NoDataFound from "../../../components/NoDataFound/index.js";

const StatusChip = ({ status }) => {
  const getChipProperties = (status) => {
    switch (status) {
      case "APPROVED":
        return {
          label: "Approved",
          color: "#D4EDDA", // Light green background
          textColor: "#155724", // Dark green text
          Icon: IoCheckmark, // Dark green text
        };
      case "REJECTED":
        return {
          label: "Rejected",
          color: "#F8D7DA", // Light red background
          textColor: "#721C24", // Dark red text
          Icon: IoCloseOutline, // Dark red text
        };
      case "PENDING":
        return {
          label: "Pending",
          color: "#FFF3CD", // Light yellow background
          textColor: "#856404", // Dark yellow text
          Icon: LuClock, // Dark yellow text
        };
      default:
        return {
          label: "Unknown",
          color: "#E0E0E0", // Gray background
          textColor: "#6C757D", // Gray text
          Icon: FaDotCircle, // Gray text
        };
    }
  };

  const { label, color, textColor, Icon } = getChipProperties(status);

  return (
    <Chip
      style={{
        backgroundColor: color,
        color: textColor,
        fontWeight: "bold",
      }}
      size="small"
      label={label}
      icon={<Icon style={{ color: textColor }} />}
    />
  );
};

export default function ApplyLeave() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);

  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [leaveDetails, setLeaveDetails] = useState([]); // Key-value pairs for leave days

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const [myLeaveData, setMyLeaveData] = useState([]);

  useEffect(() => {
    fetchPendingLeaves();
  }, []);

  const fetchPendingLeaves = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}leave/viewMyLeaves?page=${currerntPage}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          const responseData = response.data.data;
          console.log(responseData);
          setMyLeaveData(responseData);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    const thisPage = newPage + 1;

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}leave/viewMyLeaves?page=${thisPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setMyLeaveData(response.data.data);
        setCount(response.data.count);
      }
      setLoader(false);
    });
  };

  function displayLeaveDates(values) {
    const leaveArray = JSON.parse(values);
    console.log(leaveArray);
    return leaveArray;
  }

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  const getDatesInRange = (startDate, endDate) => {
    const date = new Date(startDate);
    const dates = [];
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  };

  const isSameDay = (date1, date2) =>
    date1.toDateString() === date2.toDateString();

  const excludedDates = [
    new Date(2024, 11, 14), // 14 Dec
    new Date(2024, 11, 15), // 15 Dec
  ];

  const onDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      const days = getDatesInRange(start, end);
      const validDays = days.filter(
        (day) => !excludedDates.some((ex) => isSameDay(ex, day)),
      );

      const initialLeaveDetails = validDays.map((date) => ({
        date,
        leaveType: "Full day", // Default leave type
        leaveValue: 1,
      }));
      setLeaveDetails(initialLeaveDetails);
    }
  };

  const handleLeaveTypeChange = (date, leaveType) => {
    const leaveValue = leaveType === "Full day" ? 1 : 0.5;
    setLeaveDetails((prev) =>
      prev.map((detail) =>
        isSameDay(detail.date, date)
          ? { ...detail, leaveType, leaveValue }
          : detail,
      ),
    );
  };

  // Function to handle leave day selection for specific days
  const getTotalLeaveDays = (leaveDetails) => {
    return leaveDetails.reduce((total, detail) => total + detail.leaveValue, 0);
  };

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
    reset();
    setStartDate(new Date());
    setEndDate(null);
    setLeaveDetails([]);
  };

  const validationSchema = Yup.object().shape({
    leaveType: Yup.string().required("Leave Type is required"),
    reason: Yup.string().required("Leave Reason is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const  handleRemoveLeaveDays = (date)=>{
    const updateLeaveDetails = leaveDetails.filter(item=>item.date !== date )
    setLeaveDetails(updateLeaveDetails)
  } 

  async function handleAdd(values) {
    try {
      // Prepare the payload
      const payload = leaveDetails.map((detail) => ({
        date: moment(detail.date).format("YYYY-MM-DD"), // Format date as YYYY-MM-DD
        leaveType: detail.leaveType,
        value: detail.leaveValue,
      }));

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}leave/requestLeave`,
        {
          leaveDates: payload,
          leaveType: values.leaveType,
          reason: values.reason,
          Totalvalue: getTotalLeaveDays(leaveDetails),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleFeedbackModalClose();
        fetchPendingLeaves();
      } else {
        handleNotificationCall("error", response.data.message);
      }

      console.log("API Response:", values, payload);
    } catch (error) {
      console.error("Error submitting leave details:", error);
      setLoader(false);
    }
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Apply Leave" />
        </Grid>
        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              onClick={handleFeedbackModalOpen}
            >
              Apply Leave
            </Button>
          </div>

          <div className={classes.smButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              color="primary"
              onClick={handleFeedbackModalOpen}
            >
              Leave
            </Button>
          </div>
        </Grid>
      </Grid>

      {myLeaveData.length==0 &&
      <NoDataFound height="80vh" message="No Data Found"/>
     }

      <Grid container spacing={2}>
      
    
        {myLeaveData.map((item) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={item}>
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {item.leaveType === "SICK" ? (
                    <Chip
                      style={{ background: "#ff7474", color: "#fff" }}
                      size="small"
                      label="Sick Leave"
                      icon={<MdOutlineSick color="#fff" />}
                    />
                  ) : item.leaveType === "CASUAL" ? (
                    <Chip
                      style={{ background: "#FFF574" }}
                      size="small"
                      label="Casual Leave"
                      icon={<MdOutlineTagFaces />}
                    />
                  ):
                  (
                    <Chip
                      style={{ background: "#FFF574" }}
                      size="small"
                      label="Privilege Leave"
                      icon={<MdOutlineTagFaces />}
                    />
                  )}
                </div>

                <Typography color="textSecondary" gutterBottom></Typography>
                {item.approvedBy && (
                  <Typography color="textPrimary" variant="body2" gutterBottom>
                    Requested to: <b>{getEmpName(item.approvedBy)}</b>
                  </Typography>
                )}
                <Typography color="textPrimary" variant="body2" gutterBottom>
                  Apply Date:{" "}
                  <b>{moment(new Date(item.createdAt)).format("DD-MM-YYYY")}</b>
                </Typography>

                <Typography color="textPrimary" variant="body2" gutterBottom>
                  Approval Date:
                  <b>

                    {item.approvedBy ? moment(new Date(item.updatedAt)).format("DD-MM-YYYY"): "-"}
                  </b>
                </Typography>

                <Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "20px 0px",
                    }}
                    border="1"
                  >
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Leave Type</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayLeaveDates(item.leaveDates).map((item, index) => (
                        <tr key={index}>
                          <td>{moment(item.date).format("DD-MM-YYYY")}</td>
                          <td>{item.leaveType}</td>
                          <td>{item.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
                <Typography
                  variant="body2"
                  component="p"
                  style={{
                    minHeight: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 6,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {item.reason}
                </Typography>
              </CardContent>
              <CardActions
                style={{
                  padding: "0px 16px 16px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div></div>
                {/* <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    console.info("I'm a button.");
                  }}
                >
                  Read More
                </Link> */}
                <StatusChip status={item.status} />
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog
        open={feedbackModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={handleFeedbackModalClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3 style={{ padding: "12px 12px", margin: 0 }}>Apply Leave</h3>
          {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12} lg={6}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <InputLabel shrink htmlFor="leaveType">
                      Leave Type
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="leaveType"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            onChange={(e) => onChange(e.target.value)} // Register value changes
                            error={!!errors.leaveType} // Error handling
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            <MenuItem value="">Select option</MenuItem>
                            <MenuItem value="CASUAL">Casual Leave</MenuItem>
                            <MenuItem value="SICK">Sick Leave</MenuItem>
                            <MenuItem value="PERSONAL">
                              Privilege Leave
                            </MenuItem>
                          </Select>
                        )}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.leaveType?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  {/* Date Picker */}
                  <Grid item xs={12}>
                    <InputLabel style={{ marginBottom: "8px" }} shrink>
                      Leave Dates
                    </InputLabel>
                    <DatePicker
                      selected={startDate}
                      onChange={onDateChange}
                      minDate={new Date()}
                      maxDate={addMonths(new Date(), 5)}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      inline
                      showDisabledMonthNavigation
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <InputLabel shrink htmlFor="reason">
                      Leave Reason
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        multiline
                        minRows={5}
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter your Feedback Message..."
                        name="reason"
                        {...register("reason")}
                        error={errors?.reason ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.reason?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <div style={{ background: "#faf5b1", padding: "10px" }}>
                  <Grid>
                    {leaveDetails.length > 0 && (
                      <div>
                        <h3>Selected Leave</h3>
                        <ul style={{ padding: "0" }}>
                          {leaveDetails.map((detail, index) => {
                            const isSunday = moment(detail.date).day() === 0
                            return(
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "5px",
                              }}
                            >
                              <span style={{ flex: "1",color: isSunday ?  "green" : "inherit",background: isSunday ? "#cbffd9":"transparent",padding: isSunday ? "0px 10px" :"0px" }}>
                                {/* {detail.date.toDateString()} -{" "} */}
                                {moment(detail.date).format("ddd MMM DD YYYY")}
                              </span>
                              <select
                                style={{
                                  width: "80px",
                                  border: "none",
                                  outline: "none",
                                }}
                                value={detail.leaveType}
                                onChange={(e) =>
                                  handleLeaveTypeChange(
                                    detail.date,
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="First Half">
                                  Half day - 1st Half
                                </option>
                                <option value="Second Half">
                                  Half day - 2nd Half
                                </option>
                                <option value="Full day">Full day</option>
                              </select>
                              <span style={{width: "30px",color:"#ff0000",display: "flex",justifyContent: "center" }} onClick={()=>{handleRemoveLeaveDays(detail.date)}}>
                                <FaTrashAlt size={16} />
                              </span>
                            </li>
                          )})}
                        </ul>
                      </div>
                    )}
                  </Grid>
                  <Box
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <strong>Total Leave:</strong>{" "}
                    <strong>{getTotalLeaveDays(leaveDetails)} days</strong>
                  </Box>
                  <Grid style={{ padding: "24px" }}>Your Leave Details</Grid>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleFeedbackModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
